import './swiper.js';
import './webfont.js';
import './header.js';
import './search-button.js';
import './slick.js';
import './internal-link.js';

import '../../scss/style.scss';
